<template>
  <div class="d-flex flex-column justify-center fill-height px-1">
    <div class="d-flex align-center mb-3">
      <span class="text--secondary">
        {{ $t("message.common.rateCenter") }}
      </span>
      <template v-if="info">
        <v-tooltip bottom :max-width="tooltipMaxWidth">
          <template v-slot:activator="{ on }">
            <v-icon small color="primary" v-on="on" class="ml-1">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{ info }}</span>
        </v-tooltip>
      </template>
    </div>
    <div class="average mb-1" :class="averageColor(average)">
      <span class="zmdi zmdi-circle average-icon mr-2"></span>
      <span class="mr-4">{{ averagePoints }}</span>
      <span class="text-uppercase">
        {{ averageLabel(average) }}
      </span>
    </div>
  </div>
</template>

<script>
import { averageLabel } from "@/helpers/helpers";

export default {
  name: "ExpansionPanelHeaderRate",
  props: {
    average: {
      type: Number,
      default: 0
    },
    info: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tooltipMaxWidth: 500
    };
  },
  computed: {
    averagePoints() {
      return `${this.average} ${this.$t("message.common.points")}`;
    }
  },
  methods: {
    averageLabel(average) {
      return averageLabel(average);
    },

    averageColor(average) {
      if (average >= 0 && average < 20) return "red--text text--darken-3";
      if (average >= 20 && average < 41) return "red--text";
      if (average >= 41 && average < 75) return "orange--text";
      if (average >= 75 && average < 90) return "green--text";
      if (average >= 90 && average <= 100) return "green--text text--darken-3";
    }
  }
};
</script>

<style lang="scss" scoped>
.average {
  display: flex;
  align-items: center;

  &--success {
    color: $success;
  }

  &--warning {
    color: $warning;
  }

  &--danger {
    color: $danger;
  }
}

.average-icon {
  margin-top: 2px;
  font-size: 20px;
}
</style>
